import React from 'react'
import MaterialSymbol from '../material-symbol'

const PermContactCalendar = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="perm_contact_calendar" {...props} />
))

PermContactCalendar.displayName = 'PermContactCalendar'

export default PermContactCalendar
